function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.87 69.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.53,3.52C-.12,7-.3,7.25.16,10.74c.26,1.99,1.18,5.64,2.04,8.11,2.5,7.22,3.85,16.48,4.69,32.13.77,14.32,1.93,19.37,4.3,18.62,1.83-.58,4.59-9.68,4.63-15.24.04-6.79,2.84-26.84,4.61-33.09.79-2.8,1.44-7.57,1.44-10.6,0-4.47-.46-6.02-2.45-8.16-3.34-3.6-6.82-3.35-13.89,1.02",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.41,4.31c2.85,2.85,3.19,7.47,1.09,14.54-1.2,4.02-1.69,4.53-4.62,4.82-5.99.59-7.66-.4-8.89-5.25-.62-2.45-1.57-4.73-2.12-5.07-.55-.34-1-1.65-1-2.91,0-1.76,1.32-3,5.75-5.38,3.16-1.7,6.11-3.12,6.54-3.15.44-.03,1.9,1.04,3.25,2.39",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,26.58c2.32-.44,2.52-.24,2.04,2.14-.29,1.45-1.03,7.36-1.66,13.13-1.68,15.49-3.1,24-4.01,24-.44,0-1.08-5.74-1.41-12.75-.57-12.08-1.93-23.36-3.21-26.7-.49-1.29-.12-1.35,2.55-.42,1.72.6,4.29.87,5.7.6",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg44);
export default __webpack_public_path__ + "static/media/44.3a4300cfa4984170e9c70db20f028a6a.svg";
export { ForwardRef as ReactComponent };